import PropTypes from "prop-types";
import { useEffect, useState } from "react";

export default function Screen4({ stateData }) {
  const [legalText, setLegalText] = useState("");

  useEffect(() => {
    // get data-legal-text attribute value from #bf-shopping-assistant
    const legalText = document
      .getElementById("bf-shopping-assistant")
      .getAttribute("data-legal-text");
    setLegalText(legalText);
  }, []);
  return (
    <>
      <div id="bf-chat-window-screen-4">
        <div className="wrapper">
          <div className="row">
            <div className="col">
              <h2 className="title">Retailers in {stateData.state}</h2>
              {stateData.retailers.map((retailer, index) => (
                <div key={index} style={{ margin: "10px 0" }}>
                  <a
                    href={retailer.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="retailer-link"
                  >
                    <img
                      src={retailer.logo_url}
                      alt={`${retailer.account_name} Logo`}
                      style={{ width: "50px", marginRight: "10px" }}
                    />
                    <span style={{ color: "blue", fontSize: "16px" }}>
                      Visit {retailer.account_name}
                    </span>
                  </a>
                </div>
              ))}
            </div>
            <div className="col">
              <div className="legal">
                <p>{legalText}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Screen4.propTypes = {
  stateData: PropTypes.shape({
    state: PropTypes.string.isRequired,
    retailers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};
